export default __webpack_public_path__ + "4ad16576e1a614f64f4de7419c5f10c6.png";